import { render, staticRenderFns } from "./EvaluationTable.vue?vue&type=template&id=5835e643&scoped=true&"
import script from "./EvaluationTable.vue?vue&type=script&lang=js&"
export * from "./EvaluationTable.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationTable.vue?vue&type=style&index=0&id=5835e643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835e643",
  null
  
)

export default component.exports